import { merge } from '@akerolabs/akero-vue/src/utils/helpers'

const popoutExclusion = ['modalTrigger', 'modalTriggerDelay']

const modalExclusion = [
  'buttonLabel',
  'buttonColour',
  'buttonFontColour',
  'popoutPosition',
  'popoutLocation',
]

export const scriptUrls = {
  development: 'http://l.cdn.akro.io/development/js/xConvert.min.js',
  test: 'https://cdn.akro.io/doom/js/xConvert.min.js',
  staging: 'https://cdn.akro.io/ironman/js/xConvert.min.js',
  production: 'https://cdn.akro.io/public/js/xConvert.min.js',
}

export const defaultOptions = {
  type: 'popout',
  bodyHeader: 'Are you interested in learning more?',
  bodyHeaderColour: '#ff00e6',
  bodyText:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor...',
  bodyImg:
    'https://res.cloudinary.com/net-natives-shared/image/upload/v1665591936/Pop-out%20script/space.png',
  campaignId: undefined,
  formId: undefined,
  heightFromTop: '30%',
  akeroPopoutId: 'akeroPopout',
  buttonLabel: 'Learn More',
  buttonColour: '#ff00e6',
  buttonFontColour: '#ffffff',
  popoutPosition: 'scroll',
  popoutLocation: 'right',
  defaultHeight: '400px',
  modalTrigger: 'abandonment',
  modalTriggerDelay: 300,
  env: 'production',
}

export const fixOptions = (options) => {
  if (options.modalTriggerDelay < 0) {
    options.modalTriggerDelay = 0
  }

  if (options.type === 'modal') {
    return merge({}, options, true, modalExclusion)
  }

  return merge({}, options, true, popoutExclusion)
}

export const getScriptUrl = (env = 'production') => {
  const [, subdomain] = Object.entries(scriptUrls).find(([key]) => key === env)
  return subdomain
}

export const getExport = (options = {}) => {
  const opts = merge(defaultOptions, options, true, [
    'debug',
    'preventAllTracking',
    'preview',
  ])
  return (
    `<script type="text/javascript" src="${getScriptUrl(
      opts.env,
    )}"></script>\n` +
    '<script type="text/javascript">try{xConvert.init(' +
    JSON.stringify(fixOptions(opts)) +
    ');}catch(ex){console.warn(ex.message);}</script>'
  )
}

export const getHTMLContents = (options = {}) => {
  const opts = merge(defaultOptions, options, true)
  return `<html>
    <head>
      <style type="text/css">
        html, body {
          margin: 0px;
          padding: 0px;
          height: 100%;
          font-family: Oswald, sans-serif;
        }
        .container {
          width: 100%;
          height: 100%;
          background-color: rgb(240, 240, 240);
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        .content {
          display: flex;
          justify-content: center;
          margin-top: 1rem;
          margin-bottom: 2rem;
        }
        .content-text {
          color: #000;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }
        .content-text img {
          width: 25%;
          margin: 2rem 0;
          line-height: 1.6;
        }
        .content-text h1 {
          font-size: 2.5rem;
          font-weight: 800;
          margin: 0;
          letter-spacing: -0.15rem;
          line-height: 1;
          padding: 0 3rem;
          max-width: 600px;
        }
        .content-text p {
          line-height: 1.6;
          font-size: 1.15rem;
          letter-spacing: -0.05rem;
          line-height: 1;
          font-weight: 100;
          padding: 0 4rem;
          max-width: 600px;
        }
        .cards {
          width: 80%;
          display: flex;
          justify-content: space-between;
        }
        .cards .card {
          width: 30%;
          background: #fff;
        }
        .cards .card img {
          max-width: 100%;
        }
        .cards .card h3 {
          letter-spacing: -0.05rem;
          margin: 0.75rem;
        }
        .cards .card p {
          margin: 0;
          font-weight: 100;
          margin: 0.75rem;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <section class="content">
          <div class="content-text">
            <img src="https://res.cloudinary.com/big-top/image/upload/c_fill,q_auto,dpr_auto,f_auto/c_scale,w_auto/c_limit,w_800/v1505404706/layout-builder/default-logo-dark.png"/>
            <h1>AT SED RHONCUS INTEGER METUS AT ALIQUET QUAM PENATIBUS</h1>
            <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            <br/>
            Ullamcorper at sed rhoncus integer metus aliquet quam penatibus at!
            </p>
          </div>
        </section>
        <section class="cards">
          <div class="card">
            <img src="https://res.cloudinary.com/big-top/image/upload/v1521046347/layout-builder/layout-template-images/swift-image-3.jpg"/>
            <h3>Parturient nullam consequat</h3>
            <p>Reiciendis sapiente accusantium similique, blanditiis tempore qui dolore, nobis suscipit, laboriosam nemo sunt reprehenderit aliquid quas.</p>
          </div>
          <div class="card">
            <img src="https://res.cloudinary.com/big-top/image/upload/v1521046347/layout-builder/layout-template-images/swift-image-2.jpg"/>
            <h3>Feugiat at adipiscing fringilla</h3>
            <p>Reiciendis sapiente accusantium similique, blanditiis tempore qui dolore, nobis suscipit, laboriosam nemo sunt reprehenderit aliquid quas.</p>
          </div>
          <div class="card">
            <img src="https://res.cloudinary.com/big-top/image/upload/v1521046347/layout-builder/layout-template-images/swift-image-1.jpg"/>
            <h3>Nullam dapibus</h3>
            <p>Reiciendis sapiente accusantium similique, blanditiis tempore qui dolore, nobis suscipit, laboriosam nemo sunt reprehenderit aliquid quas.</p>
          </div>
        </section>
      </div>
      <script src="${getScriptUrl(opts.env)}" type="text/javascript"></script>
      <script>
        let wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
        try {
          xConvert
            .init(${JSON.stringify(opts)})
            .then((instance) => {
              wait(100).then(() => {
                instance.adjustSizeAll()
                window.parent.postMessage('previewRenderComplete')
              })
            })
        } catch (ex) {
          console.warn(ex.message)
        }
      </script>
    </body>
  </html>`
}
